<div class="print-page" *ngIf="quote_info && presentation_info">
	<!-- HEADER -->
	<div class="row align-items-center mb-3">
		<div class="col-6 d-flex align-items-center">
			<img [src]="rest.getImagePath(store.image_id, store.ticket_image_id, rest.local_preferences.logo_image_id, rest.local_preferences.default_ticket_image_id)" style="max-height: 80px; max-width: 140px; margin-right: 12px;">
		</div>
		<div class="col-6 text-end text-right" style="font-size: 11px;">
			<strong>{{store.name}} ®</strong><br>
			{{store.address}}<span *ngIf="store.zipcode">, CP: {{store.zipcode}}</span><br>
			<span *ngIf="store.phone">Teléfono de contacto: {{store.phone}}<br></span>
			<!-- The image says "Correo electrónico: infomoblex1@gmail.com" -->
			<!-- We'll use the store's paypal_email or hardcode if we don't have it, but store has no email field. Let's just use what's available -->
		</div>
	</div>

	<!-- CLIENT & PROJECT INFO -->
	<table class="table table-bordered table-sm mb-3" style="font-size: 11px;">
		<tr>
			<td class="bg-light-green fw-bold text-center align-middle" style="width: 25%;">NUM CLIENTE</td>
			<td class="text-center align-middle" style="width: 25%;">{{quote_info.client_user?.id || ''}}</td>
			<td class="bg-light-green fw-bold text-center align-middle" style="width: 25%;">NOMBRE CLIENTE</td>
			<td class="text-center align-middle" style="width: 25%;">{{quote_info.quote.name | uppercase}}</td>
		</tr>
		<tr>
			<td class="bg-light-green fw-bold text-center align-middle">FECHA DE COTIZACIÓN</td>
			<td class="text-center align-middle">{{quote_info.quote.created | date:'dd/MM/yyyy'}}</td>
			<td class="bg-light-green fw-bold text-center align-middle">PROYECTO</td>
			<td class="text-center align-middle fw-bold">{{presentation_info.presentation.project_name | uppercase}}</td>
		</tr>
	</table>

	<!-- ITEMS TABLE -->
	<table class="table table-bordered table-sm mb-2" style="font-size: 11px;">
		<thead>
			<tr class="bg-light-green text-center fw-bold">
				<td colspan="2">{{presentation_info.presentation.symbology || 'DETALLE DE COTIZACIÓN'}}</td>
				<td style="width: 10%;">PRECIO</td>
				<td style="width: 10%;">MONEDA</td>
			</tr>
		</thead>
		<tbody>
			<ng-container *ngFor="let sInfo of presentation_info.sections">
				<ng-container *ngIf="sInfo.rows.length > 0 || sInfo.links.length > 0 || sInfo.images?.length > 0">

					<!-- Rows -->
					<tr *ngFor="let row of sInfo.rows; let i = index">
						<!-- SECTION NAME (Always rowspanned) -->
						<td *ngIf="i === 0" [attr.rowspan]="sInfo.rows.length + sInfo.links.length + (sInfo.images?.length > 0 ? 1 : 0)" class="bg-light-green text-center fw-bold align-middle" style="width: 30%;">
							{{sInfo.section.name | uppercase}}
						</td>

						<!-- ITEM DESCRIPTION -->
						<td>
							{{row.description}} <span *ngIf="row.label" class="text-danger fw-bold">{{row.label}}</span>
						</td>

						<!-- PRICE COLUMN -->
						<ng-container *ngIf="sInfo.section.price_display_mode !== 'DETAILED'">
							<td *ngIf="i === 0" [attr.rowspan]="sInfo.rows.length + sInfo.links.length" class="text-center align-middle">
								<ng-container *ngIf="sInfo.section.price_display_mode === 'SUM'">
									{{ getSectionTotal(sInfo.section.id) | number:'1.2-2' }}
								</ng-container>
							</td>
						</ng-container>
						<ng-container *ngIf="sInfo.section.price_display_mode === 'DETAILED'">
							<td class="text-center align-middle"></td> <!-- Empty for row -->
						</ng-container>

						<!-- CURRENCY COLUMN -->
						<ng-container *ngIf="sInfo.section.price_display_mode !== 'DETAILED'">
							<td *ngIf="i === 0" [attr.rowspan]="sInfo.rows.length + sInfo.links.length" class="text-center align-middle fw-bold">
								<ng-container *ngIf="sInfo.section.price_display_mode === 'SUM'">
									{{quote_info.quote.currency_id}}
								</ng-container>
							</td>
						</ng-container>
						<ng-container *ngIf="sInfo.section.price_display_mode === 'DETAILED'">
							<td class="text-center align-middle"></td> <!-- Empty for row -->
						</ng-container>
					</tr>

					<!-- Links -->
					<tr *ngFor="let link of sInfo.links; let j = index">
						<!-- SECTION NAME (Only if there were no rows) -->
						<td *ngIf="sInfo.rows.length === 0 && j === 0" [attr.rowspan]="sInfo.links.length + (sInfo.images?.length > 0 ? 1 : 0)" class="bg-light-green text-center fw-bold align-middle" style="width: 30%;">
							{{sInfo.section.name | uppercase}}
						</td>

						<!-- ITEM DESCRIPTION -->
						<td>
							{{ (quote_info.items | findQuoteItem:link.quote_item_id)?.item?.name }}
						</td>

						<!-- PRICE COLUMN -->
						<ng-container *ngIf="sInfo.section.price_display_mode !== 'DETAILED'">
							<td *ngIf="sInfo.rows.length === 0 && j === 0" [attr.rowspan]="sInfo.links.length" class="text-center align-middle">
								<ng-container *ngIf="sInfo.section.price_display_mode === 'SUM'">
									{{ getSectionTotal(sInfo.section.id) | number:'1.2-2' }}
								</ng-container>
							</td>
						</ng-container>
						<ng-container *ngIf="sInfo.section.price_display_mode === 'DETAILED'">
							<td class="text-center align-middle">
								{{ (quote_info.items | findQuoteItem:link.quote_item_id)?.quote_item?.total | number:'1.2-2' }}
							</td>
						</ng-container>

						<!-- CURRENCY COLUMN -->
						<ng-container *ngIf="sInfo.section.price_display_mode !== 'DETAILED'">
							<td *ngIf="sInfo.rows.length === 0 && j === 0" [attr.rowspan]="sInfo.links.length" class="text-center align-middle fw-bold">
								<ng-container *ngIf="sInfo.section.price_display_mode === 'SUM'">
									{{quote_info.quote.currency_id}}
								</ng-container>
							</td>
						</ng-container>
						<ng-container *ngIf="sInfo.section.price_display_mode === 'DETAILED'">
							<td class="text-center align-middle fw-bold">
								{{quote_info.quote.currency_id}}
							</td>
						</ng-container>
					</tr>

					<!-- SECTION IMAGES -->
					<tr *ngIf="sInfo.images && sInfo.images.length > 0">
						<!-- If no rows and no links, we must output the section name cell here, else it was rowspanned -->
						<td *ngIf="sInfo.rows.length === 0 && sInfo.links.length === 0" class="bg-light-green text-center fw-bold align-middle" style="width: 30%;">
							{{sInfo.section.name | uppercase}}
						</td>
						<td colspan="3" class="p-2">
							<div class="row g-2">
								<div class="col-4" *ngFor="let img of sInfo.images">
									<img [src]="rest.getImagePath(img.image_id)" class="img-fluid rounded border shadow-sm" style="max-height: 200px;">
								</div>
							</div>
						</td>
					</tr>

				</ng-container>
			</ng-container>

			<!-- TOTALS -->
			<tr class="bg-light-green fw-bold">
				<td colspan="2" class="text-end align-middle">SUBTOTAL:</td>
				<td class="text-center align-middle">{{quote_info.quote.subtotal | number:'1.2-2'}}</td>
				<td class="text-center align-middle">{{quote_info.quote.currency_id}}</td>
			</tr>
		</tbody>
	</table>

	<!-- We can also add VAT and Grand Total rows matching the style if needed -->
	<table class="table table-bordered table-sm mb-3" style="font-size: 11px;">
		<tr class="bg-light-green fw-bold">
			<td class="text-end align-middle" style="width: 80%;">I.V.A:</td>
			<td class="text-center align-middle" style="width: 10%;">{{quote_info.quote.tax | number:'1.2-2'}}</td>
			<td class="text-center align-middle" style="width: 10%;">{{quote_info.quote.currency_id}}</td>
		</tr>
		<tr class="bg-light-green fw-bold">
			<td class="text-end align-middle">PRECIO TOTAL:</td>
			<td class="text-center align-middle">{{ getPurchaseTotal() | number:'1.2-2' }}</td>
			<td class="text-center align-middle">{{quote_info.quote.currency_id}}</td>
		</tr>
	</table>

	<!-- NOTAS -->
	<div class="border border-dark bg-light-green p-2 fw-bold" style="font-size: 11px;">
		NOTAS:
	</div>
	<div class="border border-dark border-top-0 p-2" style="font-size: 11px; min-height: 60px;">
		<!-- If the user typed a specific note, show only that -->
		<div *ngIf="quote_info.quote.note" style="white-space: pre-wrap;">{{quote_info.quote.note}}</div>

		<!-- If no note was provided, show standard default terms -->
		<div *ngIf="!quote_info.quote.note" class="text-muted" style="font-size: 9px;">
			* Precios sujetos a cambios sin previo aviso.<br>
			* Esta cotización tiene una vigencia de {{quote_info.quote.valid_until | date:'shortDate'}}.<br>
			* Condiciones de pago: Contado a menos que se especifique lo contrario.
		</div>
	</div>
</div>
